import { Actions } from '@src/constants/Constants';
import SHOW_OVERLAY = Actions.SHOW_OVERLAY;
import HIDE_OVERLAY = Actions.HIDE_OVERLAY;
import CHANGE_VIEW = Actions.CHANGE_VIEW;
import IS_LOADING = Actions.IS_LOADING;

export enum ILoginView {
    login = 'login',
    register = 'register',
    forgotPassword = 'forgotPassword',
    hidden = 'hidden',
}

export interface ILoginState {
    isVisible: boolean;
    isLoading: boolean;
    view: ILoginView;
}

const initialState: ILoginState = {
    isVisible: false,
    isLoading: false,
    view: ILoginView.hidden,
};

export default function loginState(
    state: ILoginState = initialState,
    action: any,
): ILoginState {
    switch (action.type) {
        case SHOW_OVERLAY:
            return {
                ...state,
                isVisible: true,
                view: action.payload
            };

        case HIDE_OVERLAY:
            return {
                ...state,
                isVisible: false,
                view: ILoginView.hidden,
            };

        case CHANGE_VIEW:
            return {
                ...state,
                view: action.payload,
            };

        case IS_LOADING:
            return { ...state, isLoading: action.payload };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/LoginReducer.ts